'use strict';

import $ from 'jquery';
import { companyUnity } from '../../modules/select';

const profilesRede = {
  settings: {
    token: $('meta[name="csrf-token"]').attr('content'),
    $unities: $('#js-unities'),
  },

  init() {
    companyUnity();
  },
};

const s = profilesRede.settings;

export default profilesRede;
